export const easeIn = (t: number, alpha: number) => Math.pow(t, alpha);
